import axios from 'axios';

export const updateUser = (idUser, data)=>{
  return new Promise((resolve, reject) => {
    axios.patch(`${process.env.REACT_APP_URL_API}/users/${idUser}`,data)
      .then(res=>resolve(res))
      .catch(err => reject(err));
  });
}